import { useSelector } from "react-redux";
import PullToRefresh from "react-simple-pull-to-refresh";

import { MainLayout } from "layouts";

import PopupBranch from "components/ui/popup/Branch";
import PullToRefreshing from "components/common/PullToRefreshing";
import { ReportPageRightHeader } from "components/report/molecules/RightHeader";

export const DashboardPageLayout = ({
  children,
  handleRefresh,
}: {
  children: React.ReactNode;
  handleRefresh: () => Promise<unknown>;
}) => {
  //@ts-ignore
  const { userInfo } = useSelector((state) => state.user);

  return (
    <PullToRefresh
      resistance={2}
      pullingContent={<></>}
      refreshingContent={<PullToRefreshing />}
      onRefresh={handleRefresh}
    >
      <MainLayout
        withHeader
        withPartner
        withBottomTab
        headerProps={{
          isCenter: false,
          withBackButton: false,
          backgroundColor: "#0F2859",
          padding: "14px 24px 14px 24px",
          leftComponent: () =>
            PopupBranch({
              isAll: true,
              isHome: false,
              color: "#FFFFFF",
            }),
          rightComponent: () => ReportPageRightHeader({ userInfo }),
        }}
        backgroundColor="#0F2859"
      >
        {children}
      </MainLayout>
    </PullToRefresh>
  );
};
